/**
 * @user: antes
 * @emial: tangzhlyd@gmail.com
 * @data: 2021/1/19 下午4:43
 */
import http from "@/http";
import { notification } from "antd";
import { is, isNil, isEmpty, forEach, equals, filter, findIndex, map, reduce } from "ramda";
import { Pagination } from "@/hooks/useTable";
import { saveAs } from "file-saver";
import dayjs, { Dayjs } from "dayjs";
import { bpmGlobal, register } from "rantion-bpm";
import globalConst from "./global";
import { Options } from "@/store/basicData";

export interface DebouncedFunc<T extends (...args: any[]) => any> {
  (...args: Parameters<T>): ReturnType<T>;
}
export function isString(arg: any): arg is string {
  return is(String)(arg);
}

/**
 * 判断内容是空 或者 null
 * @param data
 */
export function isFalse(data: any): data is null | undefined {
  return isNil(data) || isEmpty(data);
}
export function isTrue(data: any) {
  return !isNil(data) && !isEmpty(data);
}
// eslint-disable-next-line @typescript-eslint/ban-types
export function isFunc(value: any): value is Function {
  return typeof value === "function";
}
export const isPromise = <T = any>(val: any): val is Promise<T> => {
  return isObject(val) && isFunc(val.then) && isFunc(val.catch);
};
// export function isPromise(value: any): value is Promise<any> {
// 	return typeof value === 'function' && has('then', value)
// }
/**
 * 函数节流
 * @param func 要节流的函数
 * @param wait 节流时间 默认500ms
 */
export function throttle<T extends (...args: any) => any>(
  func: T,
  wait = 500,
  waitReturn: any = {},
): DebouncedFunc<T> {
  let leading = true;
  return function (this: void, ...args: Array<any>) {
    if (!leading) {
      return waitReturn;
    }
    leading = false;
    setTimeout(() => {
      leading = true;
    }, wait);
    return func.apply(this, args);
  };
}
/**
 * filter 跟 map 组合 filter() 返回true or false true才执行 map
 * @param filterFunc
 * @param mapFunc
 * @param array 数据源 只支持数据
 */
export function filterMap<T, U>(
  filterFunc: (value: T, index: number, array: readonly T[]) => boolean,
  mapFunc: (x: T, index: number, array: readonly T[]) => U,
  array: readonly T[],
): U[] {
  return array.reduce((list: U[], item, index) => {
    const is = filterFunc(item, index, array);
    if (is) {
      list.push(mapFunc(item, index, array));
    }
    return list;
  }, []);
}

export function readerBlob(data: Blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsText(data, "utf-8");
    reader.onload = function (event: ProgressEvent<FileReader>) {
      try {
        if (event.target) {
          const data = event.target.result;
          if (isString(data)) {
            const val = JSON.parse(data); // reader.result
            resolve(val);
          }
        }
      } catch (e) {
        reject(e);
      }
    };
  });
}
export interface FilterOption {
  label: React.ReactNode;
  value?: string | number | null;
  labelEn?: string | number | null;
  sellerId?: string;
  [index: string]: any;
  children?: Omit<FilterOption, "children">[];
}
export function filterOption(inputValue: string, option?: FilterOption) {
  if (isNil(option)) {
    return false;
  }
  const label = option?.label ?? option.value?.toString();
  if (isString(label)) {
    return label.toLowerCase().includes(inputValue.toLowerCase());
  }
  return false;
}
export const TIMEFORMAT = "YYYY-MM-DD HH:mm:ss";
// 时间戳转换
export function timestampToTime(timestamp?: string) {
  return timestamp ? dayjs(timestamp).format(TIMEFORMAT) : "";
}
export interface Printer {
  donoPrint: string;
  A4: string;
  barCode: string;
}
// 打印机相关
export function getPrinterAll() {
  const str = localStorage.getItem("rantion-printer");
  if (str) {
    const printer: Printer = JSON.parse(str);
    return printer;
  }
  return undefined;
}

export const pipeFormatJsonHtml = (str?: string) => {
  if (str) {
    return formatJsonHtml(JSON.parse(str));
  }
  return "";
};

export function formatJsonHtml(msg: any) {
  const rep = "~";
  let jsonStr = JSON.stringify(msg, null, rep);
  let str = "";
  for (let i = 0; i < jsonStr.length; i++) {
    const text2 = jsonStr.charAt(i);
    if (i > 1) {
      const text = jsonStr.charAt(i - 1);
      if (rep != text && rep == text2) {
        str += "<br/>";
      }
    }
    str += text2;
  }
  jsonStr = "";
  for (let i = 0; i < str.length; i++) {
    const text = str.charAt(i);
    if (rep == text) jsonStr += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
    else {
      jsonStr += text;
    }
    if (i == str.length - 2) jsonStr += "<br/>";
  }
  return jsonStr;
}
export const isNumber = is(Number);
export function isArray(arg: any): arg is Array<any> {
  return is(Array)(arg);
}
// eslint-disable-next-line @typescript-eslint/ban-types
export function isObject(arg: any): arg is Object {
  return is(Object)(arg);
}

const format = "YYYY-MM-DD";
// 时间区间 转换 根据开始时间跟结束时间 添加后缀
export const dateToEndAndStart = (timestamp?: Array<string> | Array<Dayjs>) => {
  if (isEmpty(timestamp) || isNil(timestamp) || timestamp.length !== 2) {
    return [];
  }
  const [start, end] = timestamp;
  if (dayjs.isDayjs(start) && dayjs.isDayjs(end)) {
    return [`${start.format(format)} 00:00:00`, `${end.format(format)} 23:59:59`];
  } else if (isObject(start)) {
    return [`${dayjs(start).format(format)} 00:00:00`, `${dayjs(end).format(format)} 23:59:59`];
  } else {
    return [`${start} 00:00:00`, `${end} 23:59:59`];
  }
};
export const timesToEndAndStart = (timestamp?: Array<string> | Array<Dayjs>): string[] => {
  const format = "YYYY-MM-DD HH:mm:ss";
  if (isEmpty(timestamp) || isNil(timestamp) || timestamp.length !== 2) {
    return [];
  }
  const [start, end] = timestamp;
  if (dayjs.isDayjs(start) && dayjs.isDayjs(end)) {
    return [start.format(format), end.format(format)];
  } else if (isObject(start)) {
    return [dayjs(start).format(format), dayjs(end).format(format)];
  } else {
    return [start, end as string];
  }
};
interface Event {
  <T>(data?: T): void;
}
// 创建一个观察者模式
export class Observer<K extends string> {
  #listeners: Map<K, Array<Event>>;
  constructor() {
    this.#listeners = new Map<K, Array<Event>>();
  }
  dispatchEvent<T>(type: K, data?: T) {
    const events = this.#listeners.get(type);
    if (events && !isEmpty(events)) {
      forEach((event) => event(data), events);
    }
  }
  // isOnly 是否只能存在一个
  addListener(type: K, func: Event, option: { isOnly: boolean } = { isOnly: false }) {
    const events = this.#listeners.get(type);
    if (isNil(events) || option.isOnly) {
      this.#listeners.set(type, [func]);
      return;
    }
    events.push(func);
    this.#listeners.set(type, events);
  }
  removeEventListener(type: K, func?: Event) {
    const events = this.#listeners.get(type);
    if (events) {
      if (isNil(func)) {
        this.#listeners.delete(type);
        return;
      }
      this.#listeners.set(
        type,
        filter((event) => !equals(event.name, func.name), events),
      );
    }
  }
}
export enum NoticeObserverType {
  refresh = "REFRESH",
}
export const noticeObserver = new Observer<NoticeObserverType>();

enum ChainEnum {
  end = "END",
  next = "NEXT",
}
interface ChainFunc<T extends any[] = any> {
  (...data: T): ChainEnum;
}
// 职责链模式
export class IfChain<T extends any[]> {
  #func: ChainFunc<T> | undefined;
  #nextChain: IfChain<T>;
  public next(func: (...data: T) => ChainEnum) {
    this.#func = func;
    this.#nextChain = new IfChain();
    // TODO 这里看情况 是否要从第一个开始执行 是否注释
    this.#nextChain.start = this.start.bind(this);
    return this.#nextChain;
  }
  public start(...res: T): ChainEnum {
    if (isNil(this.#func)) {
      return ChainEnum.end;
    }
    const data = this.#func(...res);
    if (equals(data, "END")) {
      return ChainEnum.end;
    }
    if (isNil(this.#nextChain.#func)) {
      return ChainEnum.end;
    }
    return this.#nextChain.#func(...res);
  }
}
// 数组根据大小分组
export function chunk<T>(array: Array<T>, size: number) {
  size = Math.max(size, 0);
  const length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  let index = 0;
  let resIndex = 0;
  const result: Array<Array<T>> = new Array(Math.ceil(length / size));

  while (index < length) {
    result[resIndex++] = array.slice(index, (index += size));
  }
  return result;
}

export interface Func {
  (...data: any): any;
}
// 创建一个在worker 函数
export function runAsync<T extends Func>(fn: T, data: Parameters<typeof fn>) {
  const str = `onmessage = function(res) {  var data = ${
    fn.name
  }(...res.data.workerParameters); if(data instanceof Promise){
	  data.then(res=>{
	   postMessage(res)
	  })
	}else{ postMessage(data)}    };  ${fn.toString()}`;
  const url = URL.createObjectURL(
    new Blob([str], {
      type: "application/javascript; charset=utf-8",
    }),
  );
  const worker = new Worker(url);
  worker.postMessage({
    workerParameters: data,
  });
  return new Promise((resolve, reject) => {
    worker.onmessage = ({ data }) => {
      resolve(data);
      worker.terminate();
      URL.revokeObjectURL(url);
    };
    worker.onerror = (err) => {
      reject(err);
      worker.terminate();
      URL.revokeObjectURL(url);
    };
  });
}
// 凯撒加密 只支持 字符串
export function caesarCipher(str: string, shift: number, decrypt = false) {
  const s = decrypt ? (26 - shift) % 26 : shift;
  const n = s > 0 ? s : 26 + (s % 26);
  return [...str]
    .map((l, i) => {
      const c = str.charCodeAt(i);
      if (c >= 65 && c <= 90) return String.fromCharCode(((c - 65 + n) % 26) + 65);
      if (c >= 97 && c <= 122) return String.fromCharCode(((c - 97 + n) % 26) + 97);
      return l;
    })
    .join("");
}

/**
 * encrypto 加密程序
 * @param {Strng} str 待加密字符串
 * @param {Number} xor 异或值
 * @param {Number} hex 加密后的进制数
 * @return {Strng} 加密后的字符串
 */
export function encrypt(str: string, xor: number, hex: number) {
  const resultList: string[] = [];
  hex = hex <= 25 ? hex : hex % 25;
  for (let i = 0; i < str.length; i++) {
    const charCode = (str.charCodeAt(i) * 1) ^ xor;
    resultList.push(charCode.toString(hex));
  }
  return resultList.join(String.fromCharCode(hex + 97));
}

/**
 * decrypto 解密程序
 * @param {Strng} str 待加密字符串
 * @param {Number} xor 异或值
 * @param {Number} hex 加密后的进制数
 * @return {Strng} 加密后的字符串
 */
export function decrypt(str: string, xor: number, hex: number) {
  const resultList = [];
  hex = hex <= 25 ? hex : hex % 25;
  const strCharList = str.split(String.fromCharCode(hex + 97));
  for (let i = 0; i < strCharList.length; i++) {
    let charCode = parseInt(strCharList[i], hex);
    charCode = (charCode * 1) ^ xor;
    resultList.push(String.fromCharCode(charCode));
  }
  return resultList.join("");
}

// 函子
export class Functor<T> {
  protected _value: T;
  constructor(value: T) {
    this._value = value;
  }
  static of<T>(value: T) {
    return new Functor(value);
  }
  map<P extends (value: T) => any>(fn: P) {
    return Functor.of<ReturnType<typeof fn>>(fn(this._value));
  }
  join() {
    return this._value;
  }
  end(fn: (data: T) => any) {
    return fn(this._value);
  }
}

//
export function exportByParam(url: string, params?: any, fileName?: string) {
  return http(url, {
    getResponse: true,
    responseType: "blob",
    params,
  })
    .then((res: any) => {
      const content = res.response.headers.get("content-disposition");
      if (content) {
        saveAs(res.data, `${fileName}` + `.xlsx`);
        notification.success({
          message: `${fileName}下载成功`,
          description: "",
        });
      }
    })
    .catch((err) => {
      console.log(err);
      notification.error({
        message: `导出失败`,
        description: "",
      });
    });
}
export function exportByBody(url: string, data?: any, fileName?: string) {
  return http(url, {
    getResponse: true,
    responseType: "blob",
    method: "POST",
    data,
  })
    .then((res: any) => {
      const content = res.response.headers.get("content-disposition");
      if (content) {
        saveAs(res.data, `${fileName}` + `.xlsx`);
        notification.success({
          message: `${fileName}下载成功`,
          description: "",
        });
      }
    })
    .catch((err) => {
      console.log(err);
      notification.error({
        message: `导出失败`,
        description: "",
      });
    });
}
// 把对象数组 根据key 转换成map
export const makeMap = <T extends Record<string, any>, U extends keyof T>(
  list: Array<T>,
  key: U,
) => {
  if (isEmpty(list)) {
    return new Map<string, T>();
  }
  return new Map<string, T>(
    map((item) => {
      return [item[key], item];
    }, list),
  );
};
// 把接口获取的 路由树跟本地的路由树对比 过滤接口不存在的  达到路由控制的效果
export function diffTree(
  leftTree: Rantion.RouteConfig[],
  rightTree: defs.appCenter.AppDomainMenuTreeWithButtonResponseDto[],
): Rantion.RouteConfig[] {
  return reduce(
    (tree, data) => {
      const index = findIndex((res) => equals(res.name, data.routeAlias), leftTree);
      if (!equals(index, -1)) {
        const item = leftTree[index];
        item.alwaysShow = !data.hiddenFlag;
        item.meta = {
          ...item.meta,
          title: data.name || "",
          code: data.code,
          roleMenuResourceDtoList: data.buttons,
        };
        if (item.children) {
          item.children = data.children ? diffTree(item.children, data.children) : undefined;
        }
        tree.push(item);
      }
      return tree;
    },
    [] as Rantion.RouteConfig[],
    rightTree,
  );
}
// 是否多维数组
export function isMultiArr(arr: any): arr is [][] {
  return isArray(arr) && isArray(arr[0]);
}

export const requiredRules = [{ required: true }];

export function funToTable(data: any): Pagination {
  // 故意使用|| 0也取1
  return {
    current: data?.data?.pageNum || 1,
    pageSize: data?.data?.pageSize || 10,
    total: data?.data?.total,
    records: data?.data?.list,
  };
}
export function funToTableDevice(data: any): Pagination {
  return {
    current: data?.data?.current || 1,
    pageSize: (data?.data?.pageSize ?? data?.data?.size) || 10,
    total: data?.data?.total,
    records: data?.data?.records,
  };
}
export function paginationByTableToFun({ current, pageSize }: Pagination) {
  return { pageSize, pageNumber: current };
}

export function paginationByTableToCurrentSize({ current, pageSize }: Pagination) {
  return { current, size: pageSize };
}

export function replaceInnerText(parentName: string, name: string, replaceField?: string[]) {
  const parentNode = document.getElementsByClassName(parentName)[0];
  if (isNil(parentNode) || isEmpty(parentNode)) return;
  const subNodes: any = parentNode.getElementsByClassName(name);
  for (let index = 0; index < subNodes.length; index++) {
    const element = subNodes[index];
    if (replaceField?.includes(element.innerText)) {
      element.innerText = "******";
    }
  }
}
// xp to cm 对象
class UnitConversion {
  getDPI() {
    const arrDPI: Array<number> = [];
    const tmpNode = document.createElement("DIV");
    tmpNode.style.cssText =
      "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
    document.body.appendChild(tmpNode);
    arrDPI[0] = tmpNode.offsetWidth;
    arrDPI[1] = tmpNode.offsetHeight;
    tmpNode.parentNode && tmpNode.parentNode.removeChild(tmpNode);
    return arrDPI;
  }
  pxTonMm(value: number) {
    const inch = value / this.getDPI()[0];
    return inch * 25.4;
  }
  mmToPx(value: number) {
    const inch = value / 25.4;
    return inch * this.getDPI()[0];
  }
}

export const unitConversion = new UnitConversion();

// 格式化只能输入正整数
export const inputNumberToInt = (value: string) => {
  if (value) {
    return /^\d+$/.test(value) ? value : value.split(".")[0];
  } else {
    return 0;
  }
};
// 防抖可选择是否马上执行
export function throttleFun<T extends (...args: any) => any>(
  func: T,
  time = 800,
  immediate = false,
) {
  let timer: any = null;
  return function (this: unknown, ...args: any[]) {
    if (immediate) {
      func.apply(this, args);
      immediate = false;
      return;
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, time);
  };
}
export const TITLE_TYPE = {
  ADD: "新增",
  SEE: "查看",
  UPDATE: "修改",
  NULL: "新增",
  APPROVAL: "审批",
  NULL_APPROVAL: "新增审批",
};
export function isUrl(url: string) {
  //判断URL地址的正则表达式为:http(s)?://([\w-]+\.)+[\w-]+(/[\w- ./?%&=]*)?
  //下面的代码中应用了转义字符"\"输出一个字符"/"
  const Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
  return new RegExp(Expression).test(url);
}

export const disabledDate = (current: any) => {
  return current < dayjs().startOf("day");
};

export enum DoType {
  add = "ADD",
  update = "UPDATE",
  see = "SEE",
  approval = "APPROVAL",
  null = "NULL",
}

export const SHOPIFY = "shopify";
export const SHOPLINE = "shopline";
export const EBAY = "ebay";
export const AMAZON = "amazon";
//通用枚举启用/禁用
export enum Status {
  unEnable,
  enable,
}
//获取uuid
export const generateUuid = (prefix = "rantion-") => {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (
    prefix + "" + S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4()
  );
};

export function getEnv(env: keyof (typeof window)["__RANTION-ERP-ENV"]) {
  const envObject = window["__RANTION-ERP-ENV"];
  return envObject[env];
}
export async function getBpmToken() {
  const accessToken = localStorage.getItem(globalConst.accessToken); // 示例 业务系统根据自己的情况来，需要拿到业务系统的Token
  if (accessToken) {
    // 获取bpm网关的Token 这个是业务中台的实现，如果是其他系统请参考BPM网关对接文档
    const { success, data } = await API.ucenter.sysUserLogin.loginForBpmGateway.request();
    if (success && !isNil(data)) {
      bpmGlobal.setAppGlobal({
        accessToken, // 必填
        bpmToken: data.accessToken, // 必填\
      });
      return data.accessToken;
    }
    return "";
  }
  return "";
}
export function setBpmInit() {
  register();
  bpmGlobal.setAppGlobal({
    getAccessToken: () => {
      return Promise.resolve(localStorage.getItem(globalConst.accessToken) ?? "");
    },
    getBpmToken: getBpmToken,
    server_url: "/serverApi/bpm-gateway/rantion-eip",
    strategy: "RantionAccessToken", // 系统分类 必填  各个业务系统不一样 这个是业务中台的
  });
  /**
   *  设置环境变量 这里主要是BPM 网关的地址 内置三个环境变量的
   * 'development' | 'test' | 'production'
   * 如果有其他需要 可以通过 bpmGlobal.setAppGlobal(data: Partial<AppGlobalDto>) 设置 server_url
   *
   */
  // 这里需要全局处理组件抛出的错误
  bpmGlobal.warnHandler = (data) => {
    if (data.code === 401) {
      // 业务系统登录失效 需要重新登录
    }
    if (data.code === 407) {
      // BPM 网关登录失效 需要重新获取网关
      getBpmToken();
    }
  };
  getBpmToken();
}

// <rantion-bpm
// inst-id={props.instanceId}
// body-style="max-height: 70vh; overflow-y: auto;"
// task-id={props.taskId}
// do-type={bpmType.value}
// onSuccess={() => {
//   emit('search')
//   cancel()
// }}
// ref={ranrionBpmRef}
// read-id={props.readId}
// leader-id={props.leaderId}
// onClose={cancel}
// >
export function findOptionByValue(options: Options[], value: string): Options | undefined {
  for (const option of options) {
    if (option.value === value) {
      console.log(option, "直接找到该值");
      return option; // 直接找到该值
    }
    if (option.children && option.children.length > 0) {
      const found = findOptionByValue(option.children, value); // 递归查找子选项
      if (found) {
        return found;
      }
    }
  }
  return undefined; // 没有找到该值
}
export function copyText(text: string) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
    notification.success({ message: "复制成功" });
  } else {
    const textareaEl = document.createElement("textarea");
    textareaEl.setAttribute("readonly", "readonly"); // 防止手机上弹出软键盘
    textareaEl.style.position = "fixed";
    textareaEl.value = text;
    document.body.appendChild(textareaEl);
    textareaEl.select();
    document.execCommand("copy");
    document.body.removeChild(textareaEl);
    notification.success({ message: "复制成功" });
  }
}
